<template>
    <div class="float-left mr-1" v-if="convenio.idSituacaoConvenio != 9">
        <span class="text-primary">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar Aditivo"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <aditivo-form
            operacaoProp="A"
            :convenio="convenio"
            :aditivo="aditivo"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aditivo-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AditivoForm from './AditivoForm.vue'

export default {
    components: {
        AditivoForm
    },

    props: {
        convenio: Object,
        aditivo: Object
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aditivo) {
            this.$store.dispatch('addRequest')
            let aditivoDto = {
                idConvenio : this.$route.params.convenioId,
                idAditivo : aditivo.idAditivo,
                dataAditivo: new Date(),
                objeto: aditivo.objeto,
                tipoAditivo: aditivo.tipoAditivo,
                dataProrrogada: aditivo.tipoAditivo == 1 ? this.$moment(aditivo.dataProrrogada, 'DD/MM/YYYY').format('YYYY-MM-DD') : null,
                valorAditivo : aditivo.valorAditivo,
                statusAditivo: aditivo.statusAditivo,
            }
            ConveniosServicos.alterarAditivo(aditivoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Aditivo atualizado com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
